/**
 * Use this map to get the channel that a given domain should use.
 */
export const domainChannelSlugMap: Record<string, string> = {
  "ff.rowinbot.com": "socios",
  "qa.fanfest.vip": "qa",
};

export const defaultAppChannel = "home";

export function getDefaultDomainChannel(domain: string): string {
  return domainChannelSlugMap[domain] || defaultAppChannel;
}

export function isDomainSpecificChannel(domain: string): boolean {
  return Object.keys(domainChannelSlugMap).includes(domain);
}
